export default __webpack_public_path__ + "static/media/Girdle of the Living Tarim.7e505bee.jpg";